import { FC } from "react";
import Terms from "./components/Terms";

export const TermsPage: FC = () => {
	return (
		<>
			<Terms />
		</>
	);
};
